/** 游客免费首跑提示的关闭结果。 */
export interface GuestFreeFirstRunPromptResult {
    /** 弹窗结束原因。 */
    reason: 'auto' | 'close' | 'destroyed';
}

/** 展示游客免费首跑提示所需的埋点上下文。 */
export interface GuestFreeFirstRunPromptShowOptions {
    /** Raven 埋点事件分组。 */
    eventType: string;
}

/** 游客免费首跑提示 service。 */
export interface GuestFreeFirstRunPromptService {
    /** 展示提示，并在自动消失、手动关闭或销毁后返回结束原因。 */
    show(options: GuestFreeFirstRunPromptShowOptions): Promise<GuestFreeFirstRunPromptResult>;
    /** 销毁当前提示并终止等待流程。 */
    destroy(): void;
}

/** 游客免费首跑提示 service 的容器标识。 */
export const GuestFreeFirstRunPromptService = Symbol('GuestFreeFirstRunPromptService');
